import React, { useEffect } from 'react';
import { Animated,Image } from 'react-native';
import { View } from 'react-native-web';


function Loader({ duration, }) {
        const scale = new Animated.Value(1);
      
        useEffect(() => {
          pulse();
        }, []);
      
        function pulse() {
          Animated.timing(scale, {
            toValue: 2,
            duration: duration || 300,
           
            useNativeDriver: true,
          }).start(() => {
            Animated.timing(scale, {
              toValue: 1,
              duration: duration || 900,
        
              useNativeDriver: true,
            }).start(() => {
              pulse();
            });
          });
        }
  
    return (

      <Animated.View
        style={{
            
          transform: [
            {
              scale: scale
            },
          ],
        alignItems:'center',
        justifyContent:'center',
        width:'100%',
        height:'100%',
        }}>
        
        <Image source={require('../../assets/loader.svg')} style={{width:75, height:75, overflow:'hidden'}} resizeMode={'contain'}/>
       
      </Animated.View>

    );
  }
  
  export default Loader